import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form-submit"
// Handles form submission with confirmation dialogs for quiz sections
export default class extends Controller {
  static targets = ["submitButton", "submitVisual", "moveButtons"]

  trySubmit(event) {
    event.preventDefault()
    // window.onbeforeunload = null;
    if (window.confirm("Are you sure you want to submit this section?")) {
      if (this.hasMoveButtonsTarget) {
        window.$(this.moveButtonsTarget).remove()
      } else {
        window.$(".interface-move-button-yash").remove()
      }

      if (this.hasSubmitVisualTarget) {
        window.$(this.submitVisualTarget).html("Submitting...")
        window.$(this.submitVisualTarget).off("click")
        window.$(this.submitVisualTarget).css("width", "auto")
      } else {
        window.$("#submit-visual-yash").html("Submitting...")
        window.$("#submit-visual-yash").off("click")
        window.$("#submit-visual-yash").css("width", "auto")
      }

      if (this.hasSubmitButtonTarget) {
        this.submitButtonTarget.click()
      } else {
        window.$("#submit-yash").click()
      }
    }
  }

  submit(event) {
    event.preventDefault()
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.click()
    } else {
      window.$("#submit-yash").click()
    }
  }

  modalSubmit(event) {
    event.preventDefault()
    // Same as submit - triggers the hidden submit button
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.click()
    } else {
      window.$("#submit-yash").click()
    }
  }

  setupSubmit(event) {
    // Called before form submission to set up time tracking
    // This is called by the form's submit event
    const $ = window.$
    if (!$) return

    const currentQuestion = window.currentQuestion
    if (!currentQuestion) return

    // Get last time spent on current question
    const timeClicked = new Date().getTime()
    const timeToAdd = timeClicked - currentQuestion.startTime
    const totalTimeSpent = timeToAdd + Number($("#time-spent-" + currentQuestion.number + "-yash").val())
    $("#time-spent-" + currentQuestion.number + "-yash").val(totalTimeSpent)

    // Convert all time-spent values from milliseconds to seconds
    const numQuestions = $(".interface-bottom-bubble-yash").length
    for (let i = 1; i <= numQuestions; i++) {
      const integerVersion = parseInt($("#time-spent-" + i + "-yash").val() / 1000)
      $("#time-spent-" + i + "-yash").val(integerVersion)
    }

    // Stop the timer if GameTimer exists
    if (window.GameTimer && typeof window.GameTimer.stopTimer === 'function') {
      window.GameTimer.stopTimer()
    }
  }
}
